module.exports = __webpack_public_path__ + "img/aba_shata_no.d9c1dcd0.png";